import React, { useEffect } from "react";
import styles from "./SignDownload.module.scss";

type Props = {
    img: string;
    filename: string;
    phone?: string;
};

const SignDownload = (props: Props) => {
    const phone = props.phone || "987-654-3210";

    useEffect(() => {
        localStorage.signphone = phone;
    })

    return (
    <>
        <div className="content-boxD">
            <div id="Displaylife">
                <img src={`https://tacboard.com/img/${props.img}`} style={{width: "92%"}}/>
                <div className="tacboardPDFContainer applicationPDFContianer">
                    <div className="applicationPDF">
                        <span id="phoneNumberD" className="tacboardPDF">{phone}</span>
                    </div>
                </div>
            </div>
            <p>&emsp;<br/>&emsp;<br/>&emsp;<br/>&emsp;<br/>&emsp;<br/>&emsp;</p>
        </div>

        <div id="buttons">
            <a className="close-feature" href="/wedding-sign-shop">close</a>
            <a className={styles.download} download={props.filename} href={`/api/pdf/${props.img}?phone=${phone}`}><button>Download Your Sign</button></a>
        </div>
    </>)
}

export default SignDownload;
